function checkForBlockedIframe(iframe) {
    if (iframe.hasAttribute('data-cookieconsent')) {
        const parent = iframe.parentElement;
        if (iframe.style.display === "none") {
            console.log("iframe blocked by cookieconsent");
            const existingDiv = parent.querySelector('.cookieconsent-blocked-iframe');
            if (existingDiv)
                return;

            const div = document.createElement('div');
            div.style.display = 'flex';
            div.style.justifyContent = 'center';
            div.style.alignItems = 'center';
            div.style.backgroundColor = 'white';
            div.classList.add("cookieconsent-blocked-iframe");
            div.textContent = "This content is blocked by Cookiebot. Please enable cookies to view this content.";

            parent.appendChild(div);
        } else {
            const existingDiv = parent.querySelector('.cookieconsent-blocked-iframe');
            if (existingDiv)
                existingDiv.remove();
        }
    }
}

const iframeElements = document.querySelectorAll('iframe');
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === "style") {
            checkForBlockedIframe(mutation.target);
        }
    });
});

const config = {
    attributes: true,

};

iframeElements.forEach(element => {
    observer.observe(element, config);
});

for (let el of iframeElements) {
    checkForBlockedIframe(el);
}  
